import axios from "axios";
import { DataGrid, Popup } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  Item,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  Toolbar,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useState } from "react";
import TimeCell from "./TimeCell";

import "./index.css";
import ScheduleVarianceCell from "./ScheduleVarianceCell";
import PivotGridByTask from "./PivotGridByTask";
import { isQuotationRoot } from "../../../utils/quotationHierarchy";

export default function QuotationGrid(props) {
  const { quot } = props;

  const [pivotGridVisible, setPivotGridVisible] = useState(false);
  const [cTask, setCTask] = useState(null);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["quotNo", "codeNo"],
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/workR/reportByProject/${quot.quotNo}`
          );

          return result.data;
        },
      })
    );
  }, [quot]);

  const calculateSponsorDisplayValue = (data) => {
    return `${data.resp == 1 ? `V` : ``}`;
  };

  const calculateBeccoDisplayValue = (data) => {
    return `${data.resp == 2 ? `V` : ``}`;
  };

  const calculateNADisplayValue = (data) => {
    return `${data.resp == 3 ? `V` : ``}`;
  };

  const calculateDisplayValue = (data) => {
    if (isQuotationRoot(data)) {
      switch (data.cost) {
        case "TBD":
        case "-":
          return data.cost;
        default:
          return Number(data.cost).toLocaleString();
      }
    } else {
      return "";
    }
    // if (data.no) {
    //   //   if (data.no.indexOf(".") != -1) {
    //   if (!Number.isInteger(data.no)) {
    //     switch (data.cost) {
    //       case "TBD":
    //       case "-":
    //         return data.cost;
    //       default:
    //         return Number(data.cost).toLocaleString();
    //     }
    //   } else {
    //     return "";
    //   }
    // }

    // return null;
  };

  const calculateDisplayTimeUsageValue = (data) => {
    if (!(Number(data.time) > 0)) return null;
    const usage = (Number(data.workTime) / Number(data.time)) * 100;
    return Number.isFinite(usage) ? usage : null;
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#A9D08E";

      if (
        e.column.dataField == "time" ||
        e.column.dataField == "workTime" ||
        e.column.dataField == "timeUsage" ||
        e.column.dataField == "scheduleVariance"
      ) {
        e.cellElement.style.backgroundColor = "#8E5671";
        e.cellElement.style.color = "#FFF";
      }
      // } else if (e.rowType == "data" && e.data.no.indexOf(".") == -1) {
      // } else if (e.rowType == "data" && Number.isInteger(e.data.no)) {
    } else if (e.rowType == "data" && isQuotationRoot(e.data)) {
      e.cellElement.style.backgroundColor = "#007048";
      e.cellElement.style.color = "#FFF";
    }
  };

  const onClick = (e) => {
    console.debug("[onClick]");
    console.debug("e", e);

    setPivotGridVisible(true);
    setCTask(e.row.data);
  };

  return (
    <>
      <DataGrid
        id="quotationGrid"
        dataSource={dataSource}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        rowAlternationEnabled={true}
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        width={"100%"}
        height={"100%"}
        highlightChanges={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        style={{
          maxHeight: "800px",
        }}
        onCellPrepared={onCellPrepared}
      >
        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
          showScrollbar={"always"}
        />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Paging enabled={false} />
        <Sorting mode={"single"} />
        {/* <Selection mode={"single"} /> */}

        <Column
          dataField={"quotNo"}
          caption={"Quotation No."}
          visible={false}
          width={100}
          fixed={true}
        />
        <Column
          dataField={"contrNo"}
          caption={"Code No."}
          visible={false}
          width={100}
          fixed={true}
        />
        <Column
          dataField={"listNo"}
          dataType={"number"}
          //   groupCellTemplate={"listNo"}
          visible={false}
          fixed={true}
        />

        {/* <Column
          dataField={"no"}
          caption={"No"}
          dataType={"string"}
          width={60}
          fixed={true}
          defaultSortOrder="asc"
        /> */}
        <Column
          dataField={"taskCat"}
          caption={"Task Category"}
          dataType={"string"}
          // width={500}
          allowEditing={false}
          fixed={true}
        />
        {/* <Column caption={"Responsibility"} fixed={true}>
          <Column
            caption={"Sponsor"}
            width={75}
            fixed={true}
            calculateDisplayValue={calculateSponsorDisplayValue}
            // dataField={"resp"}
          />
          <Column
            caption={"BECCO"}
            fixed={true}
            calculateDisplayValue={calculateBeccoDisplayValue}
            width={75}
          />
          <Column
            caption={"N/A"}
            fixed={true}
            calculateDisplayValue={calculateNADisplayValue}
            width={75}
          />
        </Column> */}
        <Column
          dataField={"unit"}
          caption={"Unit"}
          dataType={"string"}
          width={110}
          fixed={true}
        />
        <Column
          dataField={"noOfUnit"}
          caption={"No. of Unit"}
          dataType={"string"}
          width={80}
          fixed={true}
        />
        <Column
          dataField={"unitCost"}
          caption={"Unit Cost"}
          dataType={"number"}
          format={"#,##0"}
          fixed={true}
          width={110}
        />
        <Column
          dataField={"cost"}
          caption={"Cost"}
          dataType={"number"}
          format={"#,##0"}
          fixed={true}
          width={110}
          calculateDisplayValue={calculateDisplayValue}
        />
        {/* <Column width={50} fixed={true} /> */}
        <Column
          dataField={"time"}
          caption={"Planed Time (h)"}
          width={140}
          format={{
            type: "fixedPoint",
            precision: 2,
          }}

          // cellRender={TimeCell}
        />
        <Column
          dataField={"workTime"}
          caption={"Work Time (h)"}
          width={140}
          format={{
            type: "fixedPoint",
            precision: 2,
          }}
        />
        <Column
          dataField={"timeUsage"}
          caption={"Time Usage (%)"}
          calculateDisplayValue={calculateDisplayTimeUsageValue}
          format={{
            type: "fixedPoint",
            precision: 2,
          }}
          dataType={"number"}
          width={135}
        />
        <Column
          dataField={"scheduleVariance"}
          caption={"Schedule Variance"}
          width={190}
          cellRender={ScheduleVarianceCell}
          cssClass={"bullet"}
        />
        <Column
          type={"buttons"}
          buttons={[
            {
              hint: "Details",
              icon: "fa-solid fa-magnifying-glass-plus",
              onClick: onClick,
              visible: (e) => {
                return (
                  !isQuotationRoot(e.row.data) && e.row.data.workTime > 0
                );
              },
            },
          ]}
        />

        <Toolbar>
          <Item location="before">
            <div className="informer">
              {quot.quotNo}
              {quot.AOS ? ": " + quot.AOS : ``}
            </div>
          </Item>
        </Toolbar>
      </DataGrid>
      {cTask && (
        <PivotGridByTask
          pivotGridVisible={pivotGridVisible}
          setPivotGridVisible={setPivotGridVisible}
          task={cTask}
        />
      )}
    </>
  );
}
